import { render } from "./ScreenshotBulkModal.vue?vue&type=template&id=ff73ec8c"
import script from "./ScreenshotBulkModal.vue?vue&type=script&lang=js"
export * from "./ScreenshotBulkModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__